import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f36ce163911b0014ad0543/ilmhub/src/app/curriculum-course-explorer/components/CourseExplorerClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f36ce163911b0014ad0543/ilmhub/src/components/AppLayout.tsx");
